import { computed } from 'vue';
import { useStore } from 'vuex';

import { GetUserData } from '~/constants/getters';
import { RESOURCE_TYPE } from '~/constants/user';
import { hasAnyRole } from '~/utils/roles';

export default () => {
  const store = useStore();

  const roles = computed(() => store.getters[`authStore/${GetUserData}`]?.roles || []);

  const isSecondOrderReferencesOrg = computed(() =>
    hasAnyRole(roles.value, `feature:${RESOURCE_TYPE.SECOND_ORDER_REFERENCES}`),
  );

  return { isSecondOrderReferencesOrg };
};
